export default {"src":"/_next/static/media/tick.63cef5ed.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};